<div class="p-1">
    <mat-card class="p-0">
        <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="w-100 p-2">
            <h2>Training Manual List</h2>
        </div>
        <mat-divider></mat-divider>
        <div class="mat-table admin-table">
            <div class="mat-header-row">
                <div class="mat-header-cell">Manual</div>
                <div class="mat-header-cell">Title</div>
                <div class="mat-header-cell">Date</div>
                <div class="mat-header-cell">File Name</div>
                <div class="mat-header-cell"></div>


            </div>
            <div *ngFor="let service of trainingManualList | paginate: { itemsPerPage: count, currentPage: page }"
                class="mat-row">
                <div class="mat-cell">{{service.trainingId}}</div>
                <div class="mat-cell">{{service.trainingTitle}}</div>
                <div class="mat-cell">{{service.createdOn | date:'mediumDate'}}</div>
                <div class="mat-cell">{{service.trainingLink}}</div>


                <div class="mat-cell">
                    <div class="p-1 actions">
                        <a [routerLink]="['/admin/trainingManual/AddTrainingManual', service.trainingId]" mat-mini-fab
                            color="primary" matTooltip="Edit">
                            <mat-icon>edit</mat-icon>
                        </a>
                        <button mat-mini-fab color="warn" matTooltip="Remove"
                            (click)="catalogueDelete(service.trainingId)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </mat-card>

    <div fxLayout="row wrap">
        <div fxFlex="100">
            <mat-card class="p-0 text-center">
                <pagination-controls class="product-pagination" autoHide="true" maxSize="5"
                    (pageChange)="onPageChanged($event)"></pagination-controls>
            </mat-card>
        </div>
    </div>
</div>